import React from "react";
import { Box, Divider } from "@material-ui/core";
import globalColors from "../../../../../../_metronic/_assets/sass/custom/globalColors.scss";
export const LabelTitle = (props) => {
  return (
    <Box display="flex" alignItems="center"
      style={{
        boxShadow: "none",
      }}
    >
      <Box flexGrow={1}
        style={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        <b style={{ whiteSpace: "nowrap", fontSize:"18px" }}>{props.children}</b>
      </Box>
      <Divider
        style={{
          marginBottom: "2px",
          color: "red",
          marginLeft: "5px",
          backgroundColor: globalColors.primaryColor1,
          width: "95%",
        }}
      />
    </Box>
  );
};
